var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptysearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 141,
    viewBox: "0 0 140 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 140.5C108.66 140.5 140 109.16 140 70.5C140 31.8401 108.66 0.5 70 0.5C31.3401 0.5 0 31.8401 0 70.5C0 109.16 31.3401 140.5 70 140.5Z",
    fill: "#F7F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 140.5H28V49.9665C31.9592 49.9621 35.755 48.3874 38.5545 45.5878C41.3541 42.7882 42.9289 38.9924 42.9333 35.0332H97.0667C97.0625 36.9945 97.4473 38.9371 98.1988 40.7487C98.9503 42.5603 100.054 44.2049 101.445 45.5873C102.827 46.979 104.472 48.0827 106.284 48.8344C108.096 49.5861 110.038 49.9709 112 49.9665V140.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9996 95.7004C82.3708 95.7004 92.3996 85.6716 92.3996 73.3004C92.3996 60.9292 82.3708 50.9004 69.9996 50.9004C57.6284 50.9004 47.5996 60.9292 47.5996 73.3004C47.5996 85.6716 57.6284 95.7004 69.9996 95.7004Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9196 83.8608L70 75.9412L62.0804 83.8608L59.4405 81.2209L67.3601 73.3013L59.4405 65.3817L62.0804 62.7419L70 70.6615L77.9196 62.7419L80.5595 65.3817L72.6399 73.3013L80.5595 81.2209L77.9196 83.8608Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1331 101.301H57.8664C56.32 101.301 55.0664 102.554 55.0664 104.101C55.0664 105.647 56.32 106.901 57.8664 106.901H82.1331C83.6795 106.901 84.9331 105.647 84.9331 104.101C84.9331 102.554 83.6795 101.301 82.1331 101.301Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5337 112.5H49.467C47.9206 112.5 46.667 113.754 46.667 115.3C46.667 116.846 47.9206 118.1 49.467 118.1H90.5337C92.0801 118.1 93.3337 116.846 93.3337 115.3C93.3337 113.754 92.0801 112.5 90.5337 112.5Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptysearch);
export default __webpack_public_path__ + "static/media/emptysearch.0a3c32019e9a29d439514b3904068100.svg";
export { ForwardRef as ReactComponent };